import { SET_MESSAGE, CLEAR_MESSAGE } from 'src/actions/types'

const initialState = {}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case SET_MESSAGE:
      return {
        event: payload.event,
        title: payload.title,
        message: payload.message,
        type: payload.type,
      }

    case CLEAR_MESSAGE:
      return {}

    default:
      return state
  }
}
